<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/loZMNY/tc-custom/9781488060526.jpg?1731055886988" alt="This image is the cover for the book His Christmas Wish, Wander Canyon"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">His Christmas Wish, Wander Canyon
      </h1>
      <p class="bookDescription body article font2">
        <b>Sparks fly between an orphan’s uncle and his preschool teacher in this heartwarming inspirational holiday romance.</b><br/><br/>To make his little nephew happy, this bachelor will need help . . . <br/><br/>After his nephew, Cole, is orphaned, Jake Sanders vows to give the little boy the best Christmas possible . . . except Jake doesn’t know the first thing about kids! So when Cole’s preschool teacher, Emma Mullins, offers to pitch in, Jake’s grateful for her guidance. But while Jake and Emma share an immediate connection, their blossoming love must first survive the secret she’s hiding . . . <br/><br/><b>From Harlequin Love Inspired: Uplifting stories of faith, forgiveness and hope.</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Allie Pleiter
      </h2>
      
      <p class="authorDescription body article">An avid knitter, coffee junkie, and devoted chocoholic, Allie Pleiter spends her days writing books and finding new ways to avoid housework. She grew up in Connecticut, holds a BS in Speech from Northwestern University, and speaks nationally on writing, faith, and creative productivity. Allie currently lives in suburban Chicago, Illinois. Sign up for her newsletter at&#160;http://alliepleiter.com/contact.html</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0981127c